<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Orders</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a :href="route('admin.orders.index')">Orders</a>
                            </li>
                            <li class="breadcrumb-item active">{{ order.order_no }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="left-bordered-card"><strong>Order
                                Date:</strong> <br><br>
                                {{ formatDateTime(order.created_at) }}
                            </div>
                        </div> <!---->
                        <div class="col-md-4">
                            <div class="left-bordered-card">
                                <strong>Order
                                    Status:</strong>
                                <form class="assign-form">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <select v-model="form.status" id="" class="form-control form-control-sm"
                                                    required>
                                                <option v-for="(status,index) in order_statuses" :key="index"
                                                        :value="status">
                                                    {{ status }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-4">
                                            <button @click="updateOrderStatus"
                                                    class="btn btn-sm btn-primary glow mb-1 mb-sm-0 mr-0"
                                                    :disabled="updatingOrderStatus">
                                                Update
                                                <i class="fa fa-spinner fa-spin" v-if="updatingOrderStatus"/>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <template v-if="order.type==='DELIVERY'">
                            <div class="col-md-4">
                                <div class="left-bordered-card">
                                    <strong>Assigned To:</strong>
                                    <form class="assign-form">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <select v-model="form.rider_id" id=""
                                                        class="form-control form-control-sm"
                                                        required>
                                                    <option :value="null">Select a rider</option>
                                                    <option v-for="rider in riders" :key="rider.id"
                                                            :value="rider.id">
                                                        {{ rider.first_name }} {{ rider.last_name }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-4">
                                                <button @click="assignRider"
                                                        class="btn btn-sm btn-primary glow mb-1 mb-sm-0 mr-0"
                                                        :disabled="assigningRider">
                                                    Update
                                                    <i class="fa fa-spinner fa-spin" v-if="assigningRider"/>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </template>
                        <div class="col-md-4">
                            <div class="left-bordered-card"><strong>Payment
                                Status:</strong>
                                <form v-if="can_update_payment_status" class="assign-form">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <select v-model="form.payment_status" id=""
                                                    class="form-control form-control-sm" required>
                                                <option v-for="(status, index) in payment_statuses" :key="index"
                                                        :value="status">
                                                    {{ status }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-4">
                                            <button
                                                class="btn btn-sm btn-primary glow mb-1 mb-sm-0 mr-0"
                                                @click="updatePaymentStatus"
                                                :disabled="updatingPaymentStatus">
                                                Update
                                                <i class="fa fa-spinner fa-spin" v-if="updatingPaymentStatus"/>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                <template v-else>
                                    <br><br>
                                    <span>{{ getPaymentStatus(form.payment_status) }}</span>
                                </template>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="left-bordered-card"><strong>Payment
                                method:</strong> <br><br> <span
                            >
                                {{ order.payment_method_label || order.payment_channel }}
                            </span></div>
                        </div>
                        <div class="col-md-4">
                            <div class="left-bordered-card"><strong>Ordered
                                from:</strong> <br><br>
                                {{ order.ordered_from ?? "UNKNOWN" }}
                                <span v-if="order.admin" class="font-weight-bold"> - {{ order.admin.first_name + " " + order.admin.last_name}}</span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="left-bordered-card"><strong>Scheduled Time:</strong> <br><br>
                                {{ order.scheduled_time ?? "NOW" }}
                            </div>
                        </div>
                        <div class="col-md-4" v-if="order.loyalty_points_used > 0">
                            <div class="left-bordered-card"><strong>Loyalty Points Used/Worth:</strong> <br><br>
                                {{ order.loyalty_points_used }} points
                                /₦{{ order.loyalty_points_used * order.loyalty_points_exchange_rate }}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <form>
                                <h4 class="form-section"><i
                                    class="feather icon-info"></i>
                                    Order Details ({{ order.order_no }}) — {{ order.type }}
                                </h4>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="left-bordered-card">
                                            <div class="row">
                                                <div class="col-md-6"><strong>Customer
                                                    Details:</strong> <br><br>
                                                    <span>
                                                        <i class="feather icon-user"></i>
                                                        {{ customerName }}
                                                    </span> <br>
                                                    <span>
                                                        <i class="feather icon-home"></i>
                                                        {{
                                                            order?.user?.addresses[0]?.address ?? null
                                                        }} {{ order?.user?.addresses[0]?.state?.name ?? null }}
                                                    </span> <br> <span>

                                                </span> <br></div>
                                                <div class="col-md-6"><br><br
                                                > <span><i
                                                    class="feather icon-mail"></i> <a
                                                    v-if="customerEmail"
                                                    :href="'mailto:'+ customerEmail">
                                                        {{ customerEmail }}
                                                    </a></span> <br> <span><i
                                                    class="feather icon-phone"></i> <a
                                                    v-if="customerPhone"
                                                    :href="'tel:'+ customerPhone">
                                                        {{ customerPhone }}
                                                    </a></span></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <strong>Recipient Details:</strong>
                                                    <br><br>
                                                    <span><i
                                                        class="feather icon-user"></i>
                                                        {{
                                                            order?.address?.name ?? customerName
                                                        }}
                                                    </span> <br> <span><i
                                                        class="feather icon-home"></i>
                                                    {{
                                                            order?.address?.address ?? null
                                                        }} {{ order?.address?.state?.name ?? null }}
                                                    </span> <br>
                                                    <span><i class="feather icon-map-pin"></i>
                                                        Latitude: {{ order?.address?.latitude }}
                                                    </span>
                                                </div>
                                                <div class="col-md-6">
                                                    <br><br>
                                                    <span><i class="feather icon-mail"></i>
                                                        <a
                                                            v-if="customerEmail"
                                                            :href="`mailto: ${customerEmail}`">
                                                            {{ customerEmail }}
                                                        </a>
                                                    </span> <br>
                                                    <span>
                                                        <i
                                                            class="feather icon-phone"></i> <a
                                                        v-if="recipientPhone"
                                                        :href="`tel: ${recipientPhone}`">
                                                            {{ recipientPhone }}
                                                        </a>
                                                    </span><br>
                                                    <span><i class="feather icon-map-pin"></i>
                                                        Longitude: {{ order?.address?.longitude }}
                                                    </span> <br>
                                                </div>
                                            </div>
                                        </div>
                                    </div> <!----></div>
                            </form>

                        </div>

                        <div class="col-md-6">
                            <form>
                                <h4 class="form-section"><i
                                    class="feather icon-shopping-cart"></i>
                                    Delivery Instructions ({{ order.order_no }}) — {{ order.type }}
                                </h4>
                                <div class="form-group">
                                    <textarea rows="3" placeholder="Add note" disabled required="required"
                                              class="form-control">{{order.delivery_instruction}}</textarea>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <!--                                        <button type="submit"-->
                                        <!--                                                class="btn btn-primary glow mb-1 mb-sm-0 mr-0 align-self-start">-->
                                        <!--                                            Edit-->
                                        <!--                                        </button>-->
                                    </div>
                                </div>
                            </form>
                            <div class="left-bordered-card" v-if="order.store_free_delivery">
                                <div class="row">
                                    <div class="col-md-6">
                                        <strong class="text-danger">Kilimanjaro Free Delivery Order</strong>
                                        <br><br><br>
                                        <p></p>
                                        <p><strong>Order Number: </strong> {{ order.free_delivery_order_number }}</p>
                                        <p><strong>Restaurant Name: </strong> {{ order.free_delivery_restaurant_name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <form class="mt-4">
                                <h4 class="form-section"><i
                                    class="feather icon-shopping-cart"></i>
                                    Order Items
                                </h4>
                                <div class="table-responsive">
                                    <table id="users-list-datatable" class="table">
                                        <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th width="100px">Product Image</th>
                                            <th>Product</th>
                                            <th>Toppings</th>
                                            <th>Ingredients</th>
                                            <th>Cost (₦)</th>
                                            <th>Toppings price (₦)</th>
                                            <th>Quantity</th>
                                            <th class="text-right">Total (₦)</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(orderItem, index) in order.order_items" :key="index"
                                            v-if="orderItem.type!== 'two_sides_of_the_jungle' ? true : (orderItem.second_side !== null)">
                                            <td>{{ index + 1 }}</td>
                                            <td>
                                                <div><img
                                                    :src="orderItem.product?.product_images[0].image_url "
                                                    class="img-fluid cursor-pointer"></div>
                                            </td>
                                            <td>
                                                <template v-if="orderItem.custom_order_name">
                                                    {{ orderItem.custom_order_name }}{{ formatProductSize(orderItem) }}<br>
                                                    <template v-if="orderItem.pizza_crust">
                                                        Pizza Crust: {{ orderItem.pizza_crust }}<br>
                                                    </template>
                                                    First Side: {{ orderItem.product?.name }}<br>
                                                    Second Side: {{ orderItem.second_side.product?.name }}
                                                </template>

                                                <template v-else>
                                                    {{ orderItem.product?.name }}{{ formatProductSize(orderItem) }}<br>
                                                    <template v-if="orderItem.pizza_crust">
                                                        Pizza Crust: {{ orderItem.pizza_crust }}
                                                    </template>
                                                    <br>
                                                    <template v-if="orderItem.deal_name">
                                                        Deal Name: {{ orderItem.deal_name }}
                                                    </template>
                                                </template>

                                            </td>
                                            <td>
                                                <span v-for="topping in orderItem.toppings" :key="topping.topping_id">
                                                    {{ topping.name }}<template v-if="topping.quantity > 1"> x{{ topping.quantity }}</template><br>
                                                </span>
                                            </td>
                                            <td>
                                                <template v-if="orderItem.custom_order_name">
                                                    <template v-if="orderItem.ingredients?.length > 0">
                                                        First Side:
                                                        <span v-for="ingredient in orderItem.ingredients"
                                                              :key="ingredient.ingredient_id">
                                                            {{ ingredient.name }}<br>
                                                        </span>
                                                        <br>
                                                    </template>

                                                    <template v-if="orderItem.second_side.ingredients?.length > 0">
                                                        Second Side:
                                                        <span v-for="ingredient in orderItem.second_side.ingredients"
                                                              :key="ingredient.ingredient_id">
                                                            {{ ingredient.name }}<br>
                                                        </span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <span v-for="ingredient in orderItem.ingredients"
                                                          :key="ingredient.ingredient_id">
                                                        {{ ingredient.name }}<br>
                                                    </span>
                                                </template>
                                            </td>
                                            <td>
                                                <template v-if="orderItem.custom_order_name">
                                                    {{ orderItem.grand_total }}
                                                </template>
                                                <template v-else>
                                                    {{ orderItem.price - (orderItem.discount_amount ?? 0) }}
                                                </template>
                                                <template v-if="orderItem.is_discounted">
                                                    (Discount price)
                                                </template>
                                            </td>
                                            <td>{{ orderItem.toppings_price ?? 0 }}</td>
                                            <td>{{ orderItem.quantity }}</td>
                                            <td class="text-right">
                                                {{ orderItem.grand_total }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="7">Subtotal</td>
                                            <td class="text-right">
                                                ₦{{ order.grand_total - order.delivery_fee }}
                                            </td>
                                        </tr>
                                        <tr v-if="order.discount && !order.referral_code && !order.pgc_gift_card_id">
                                            <td></td>
                                            <td colspan="7">Discount</td>
                                            <td class="text-right">
                                                ₦{{ order.discount ?? 0 }}
                                            </td>
                                        </tr>
                                        <tr v-if="order.referral_code">
                                            <td></td>
                                            <td colspan="7">Referral Code ({{ order.referral_code }})</td>
                                            <td class="text-right">
                                                ₦{{ order.referral_user_amount || order.discount || 0 }}
                                            </td>
                                        </tr>
                                        <tr v-if="order.pgc_gift_card_id">
                                            <td></td>
                                            <td colspan="7">Gift Card ({{ order.gift_card?.code || 'PGC' }})</td>
                                            <td class="text-right">
                                                ₦{{ order.gift_card_amount || 0 }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="7">Customer Balance Applied</td>
                                            <td class="text-right">
                                                ₦{{ order.balance_applied ?? 0 }}
                                            </td>
                                        </tr>
<!--                                        <tr>-->
<!--                                            <td></td>-->
<!--                                            <td colspan="7">Loyalty Points Used\Worth</td>-->
<!--                                            <td class="text-right">-->
<!--                                                {{ order.loyalty_points_used }} points-->
<!--                                                /₦{{ order.loyalty_points_used * order.loyalty_points_exchange_rate }}-->
<!--                                            </td>-->
<!--                                        </tr>-->
                                        <tr>
                                            <td></td>
                                            <td colspan="7">Delivery Fee:</td>
                                            <td class="text-right">
                                                ₦{{ order.delivery_fee }}
                                            </td>
                                        </tr> <!---->
                                        <tr>
                                            <td></td>
                                            <th colspan="7">Total</th>
                                            <th class="text-right">₦{{ order.grand_total - order.discount }}</th>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <th colspan="7">
                                                {{ form.payment_status === "PAID" ? "Amount Paid" : "Amount to Pay" }}
                                            </th>
                                            <th class="text-right">₦{{ order.amount_paid }}</th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2';
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import {formatDateTime} from "../../utils";
import {paymentStatusLabel} from "../../Shared/paymentStatus";

export default {
    metaInfo: {title: 'Order'},
    props: [
        'order',
        'order_statuses',
        'payment_statuses',
        'riders',
        'can_update_payment_status',
    ],
    layout: Layout,
    name: 'OrderShow',
    components: {
        Link,
    },
    mixins: [
        DeleteAlert
    ],
    data() {
        return {
            updatingPaymentStatus: false,
            updatingOrderStatus: false,
            assigningRider: false,
            baseUrl: window.location.origin,
            amountPaid: 0,
            errors: {},
            form: {
                status: null,
                payment_status: null,
                delivery_instructions: null,
                rider_id: null,
            }
        }
    },
    computed: {
        customerName() {
            if (! this.order?.user) {
                return '—';
            }

            return `${this.order.user.first_name} ${this.order.user.last_name}`.trim() || '—';
        },
        customerEmail() {
            return this.order?.user?.email ?? null;
        },
        customerPhone() {
            return this.order?.user?.phone ?? null;
        },
        recipientPhone() {
            return this.order?.address?.phone ?? this.customerPhone;
        },
    },
    mounted() {
        this.form.status = this.order.status;
        this.form.delivery_instructions = this.order.delivery_instructions;
        this.form.rider_id = this.order.rider_id;
        this.form.payment_status = this.order?.transaction?.status ?? null;

        this.amountPaid = parseFloat(this.order.grand_total) - (parseFloat(this.order.loyalty_points_used) * parseFloat(this.order.loyalty_points_exchange_rate)) - parseFloat(this.order.balance_applied) - parseFloat(this.order.discount);

    },

    methods: {
        formatDateTime,
        formatProductSize(orderItem) {
            return orderItem.size?.name ? ` (${orderItem.size.name})` : '';
        },
        getPaymentStatus(status) {
            return paymentStatusLabel(status, this.payment_statuses);
        },
        async assignRider() {
            this.assigningRider = true;
            try {
                const response = await axios.post(route('admin.orders.assign-rider'), {
                    'order_id': this.order.id,
                    'rider_id': this.form.rider_id,
                });
                this.assigningRider = false
                this.$swal.fire({
                    title: "Success",
                    text: `Rider assigned successfully`,
                    type: "success",
                    confirmButtonColor: "#3085d6",
                });
            } catch (error) {
                console.error(error);
                this.assigningRider = false;
            }

        },

        async updateOrderStatus() {
            await this.updateStatus('order');
        },

        async updatePaymentStatus() {
            this.updatingPaymentStatus = true;

            const details = {
                title: "This is a pending order with payment method of Wallet, Would you like to deduct the amount from the user's wallet?",
                text: "You won't be able to revert this!",
            }

            if (this.order.transaction.status !== "PAID" && this.order.payment_channel === "WALLET" && this.form.payment_status === "PAID") {
                const response = await this.deleteAlert(details.title, details.text, true, "#3085d6", "#d33", "Yes, Deduct", "No, just change the status")
                    ? await this.updateStatus('payment', true)
                    : await this.updateStatus('payment');

                if (response.status !== 200) {
                    this.$swal.fire({
                        title: "Error",
                        text: response.message || `Something went wrong`,
                        type: "error",
                        confirmButtonColor: "#3085d6",
                    });
                }

            } else {
                await this.updateStatus('payment')
            }

        },
        async updateStatus(type, deductFromWallet = false) {

            let routeName, data;
            if (type === 'order') {
                this.updatingOrderStatus = true;
                routeName = route('admin.orders.update-order-status');
                data = {
                    order_id: this.order.id,
                    status: this.form.status
                }
            } else {
                this.updatingPaymentStatus = true;
                routeName = route('admin.orders.update-payment-status');
                data = {
                    order_id: this.order.id,
                    status: this.form.payment_status,
                    deduct: deductFromWallet,
                }
            }

            try {

                const response = await axios.post(routeName, data);
                type === 'order' ? this.updatingOrderStatus = false : this.updatingPaymentStatus = false;
                return response;
            } catch (error) {
                console.error(error);
                type === 'order' ? this.updatingOrderStatus = false : this.updatingPaymentStatus = true;
                return {
                    status: error.response?.status || 500,
                    message: error.response?.data?.message || "An unexpected error occurred.",
                };
            }

        },
    }
}
</script>

<style scoped>
.left-bordered-card {
    background: #fff;
    border: 1px solid #f0f0f0;
    border-left: 2px solid #3bafda;
    border-radius: 4px;
    padding: 1em;
    margin: 0.5em 0;
}
</style>
